








































































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {getHost} from '@/plugins/axios'
import {Colors, notify} from '@/modules/core/notification'
import {State} from 'vuex-class'
import JWTToken from '@/modules/auth/types'
import client from '@/base-http'
import {AxiosResponse} from 'axios'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import WampManager from '@/components/dev/WampManager.vue'
import { Method } from 'axios'

/**
 * Panel para desarrolladores
 */
@Component({
    components: { WampManager },
})
export default class DevPanel extends Vue {
    @Prop({type: Boolean, default: false})
    public value: boolean

    @State(state => state.auth.token)
    public token: JWTToken

    public notification = {
        message: '',
        color: Colors.Success,
        options: {
            notShowInCenter: false,
        },
    }

    public httpRequest = {
        url: '',
        method: 'GET' as Method,
        data: {},
    }

    public httpResponse: AxiosResponse | null = null

    public serverUrl = getHost()
    public get parsedData () {
        if (!this.httpResponse || !this.httpResponse.data) {
            return [];
        }

        const mapObject = (object: KeyValuePair) => {
            return Object.keys(object).map(key => {
                const value = object[key]
                return {
                    name: key, items: [],
                }
            })
        }

        return mapObject(this.httpResponse.data)
    }

    public get displaySizeOverlay () {
        return this.$store.state.displaySizeOverlay
    }

    public set displaySizeOverlay (value: boolean) {
        this.$store.commit('toggleSizeOverlay', value)
    }

    public get enabledModuleNames () {
        return this.$store.state.enabledModules
    }

    public async makeRequest () {
        const { method, url, data } = this.httpRequest
        this.httpResponse = await client.request({
            method, url, data,
        })
    }

    public sendNotification () {
        notify(this.notification.message, this.notification.color, this.notification.options)
    }

    public saveSettings () {
        localStorage.setItem('config.server', this.serverUrl)
    }
}
